"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Auth = _interopRequireDefault(require("./Auth"));

var _redux = require("redux");

var _ContentGroups = _interopRequireDefault(require("./ContentGroups"));

var _FavoriteBlog = _interopRequireDefault(require("./FavoriteBlog"));

var _Modals = _interopRequireDefault(require("./Modals"));

var _UserSettings = _interopRequireDefault(require("./UserSettings"));

var _default = (0, _redux.combineReducers)({
  auth: _Auth.default,
  contentGroups: _ContentGroups.default,
  favoriteBlog: _FavoriteBlog.default,
  modals: _Modals.default,
  userSettings: _UserSettings.default
});

exports.default = _default;
module.exports = exports.default;